import { render, staticRenderFns } from "./StatisticsActionBar.vue?vue&type=template&id=22376f70"
import script from "./StatisticsActionBar.vue?vue&type=script&lang=js"
export * from "./StatisticsActionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports